/**
 * Returns the currency symbol for a given ISO 4217 currency code.
 * e.g. "USD" → "$", "EUR" → "€", "GBP" → "£", "INR" → "₹"
 */
export function getCurrencySymbol(currencyCode: string): string {
  try {
    const parts = new Intl.NumberFormat("en", {
      style: "currency",
      currency: currencyCode,
    }).formatToParts(0);
    return parts.find((p) => p.type === "currency")?.value ?? currencyCode;
  } catch {
    return currencyCode;
  }
}

/**
 * Formats an amount with the given ISO 4217 currency code.
 * e.g. formatCurrencyAmount(9.99, "USD") → "$9.99"
 */
export function formatCurrencyAmount(amount: number, currencyCode: string): string {
  try {
    return new Intl.NumberFormat("en", {
      style: "currency",
      currency: currencyCode,
    }).format(amount);
  } catch {
    return `${currencyCode} ${amount.toFixed(2)}`;
  }
}
